import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse,
} from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { LoggerFactory } from '../diagnostics';
import { AuthService } from './abstract';

@Injectable()
export class Auth401Interceptor implements HttpInterceptor {
	constructor(readonly auth: AuthService, readonly logFactory: LoggerFactory, readonly zone: NgZone) {}

	readonly logger = this.logFactory.createLogger('401 Interceptor');

	readonly ignoreUrls = ['/api/auth/token-by-invitation-code'];

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		//req.url
		return next.handle(req).pipe(
			tap(
				() => {},
				async err => {
					if (err instanceof HttpErrorResponse) {
						if (err.status === 401 && !this.allowUrl(req.url)) {
							this.auth.clearToken();
							this.logger.error(String(err.message));
							if (!this.isCurrentPageSignIn()) {
								this.zone.runTask(async () => {
									await this.auth.navigateToSignInPage();
									// reset page state see task #838522
									document.location.reload();
								});
							}
						}
					}
				}
			)
		);
	}

	allowUrl(url) {
		let isAllow = false;

		this.ignoreUrls.forEach(u => {
			if (url.includes(u)) {
				isAllow = true;
			}
		});

		return isAllow;
	}

	isCurrentPageSignIn() {
		const url = new URL(location.href);
		const isSignIn = url.pathname.includes('entry/signin');
		return isSignIn;
	}
}
